/*
 * @Descripttion: 
 * @Author: huxianglong
 * @Date: 2023-07-03 10:59:04
 * @LastEditors: sueRimn
 * @LastEditTime: 2023-12-25 10:02:00
 */
import { ILoginParam } from '@/api/types'
import emitter from './mitt'

window.globalMethods = {
  closeApp() {
    window.FORM.closeApp()
  },
  onMax() {
    window.FORM.maxmin()
  },
  onMin() {
    window.FORM.minim()
  },
  getClientCalc() {
    window.FORM.calc()
  },
  getClientDraft() {
    window.FORM.draft()
  },
  onCloseCalc() {
    window.FORM.closeCalc()
  },
  onCloseDraft() {
    window.FORM.closeDraft()
  },
  onSendPlanId(planId: number) {
    window.FORM.loginCallback(planId)
  },
  getClientName() {
    return window.FORM.machintName()
  },
  getClientBeginTime() {
    window.FORM.begin()
  },
  serverAddress() {
    return window.FORM.serverAddress()
  },

  getClientEndTime() {
    return new Promise<void>((resolve, reject) => {
      window.FORM.end()
      resolve()
    })
  },
  exportSetComplete() {
    // 设置半个小时后，广播到btn，放开交卷
    emitter.emit('complete')
  },
  exportUploadClip() {
    emitter.emit('noticeClip')
  },
  exportMessage(title: string) {
    emitter.emit('message', title)
  },
  exportCheatNotice(num: number) {
    emitter.emit('cheatNotice', num)
  },
  exportLoginTest(param: string) {
    const obj: Omit<ILoginParam, 'MachineName'> = JSON.parse(param)
    emitter.emit('loginTest', obj)
  },
  exportReplacement(name: string) {
    emitter.emit('replacement', name)
  },
}
